<script setup lang="ts">
import { computed } from 'vue'
import { Cloud, FolderOpen } from '@lucide/vue'
import { Button, InlineAlert } from 'catalyst-vue'
import type { Comic } from '@tanko/shared'
import LibraryOverlay from './library-overlay.vue'
import { useControlSize } from '../../lib/library-layout'

const props = defineProps<{ comic?: Comic; cloudPageCount?: number }>()
const emit = defineEmits<{ close: []; choose: [source: 'local' | 'cloud'] }>()
const controlSize = useControlSize()
const mismatch = computed(() => props.comic && props.cloudPageCount !== undefined && props.comic.pageCount !== props.cloudPageCount)
</script>

<template>
  <LibraryOverlay :open="!!comic" title="選擇閱讀來源" :description="`「${comic?.title ?? ''}」同時有本地檔案與私人雲端副本。`" @close="$emit('close')">
    <InlineAlert v-if="mismatch" tone="warning">兩個來源的頁數不同，不會自動配對、覆蓋或重上傳。請選擇這次要讀的版本。</InlineAlert>
    <div class="source-comparison">
      <div><FolderOpen :size="21" aria-hidden="true" /><span>本地檔案</span><strong>{{ comic?.pageCount ?? 0 }} 頁</strong></div>
      <div><Cloud :size="21" aria-hidden="true" /><span>私人雲端</span><strong>{{ cloudPageCount ?? 0 }} 頁</strong></div>
    </div>
    <p class="muted-copy">閱讀來源只影響這次載入的圖片；不會變更或刪除另一份內容。</p>
    <template #actions>
      <Button outline :size="controlSize" @click="$emit('close')">取消</Button>
      <Button outline :size="controlSize" @click="$emit('choose', 'local')"><FolderOpen :size="17" aria-hidden="true" />讀本地 · {{ comic?.pageCount ?? 0 }} 頁</Button>
      <Button color="primary" :size="controlSize" @click="$emit('choose', 'cloud')"><Cloud :size="17" aria-hidden="true" />讀雲端 · {{ cloudPageCount ?? 0 }} 頁</Button>
    </template>
  </LibraryOverlay>
</template>
